import { Component } from '@angular/core';
import { ApolloService, Collections_Bool_Exp, getCollections_collections } from 'src/gql-generated/generated';
import { OrganizationService } from 'src/app/services/organization.service';
import { FormControl, Validators } from '@angular/forms';
import { ConnectionService } from 'src/app/services/connection.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { SmartSelectSettings, SmartSelectComponent } from '../shared/smart-select/smart-select.component';
import { NgIf, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-chat-new',
    templateUrl: './chat-new.component.html',
    styleUrl: './chat-new.component.scss',
    imports: [
        NgIf,
        RouterLink,
        SmartSelectComponent,
        NgClass,
        MatIcon,
        MatButton,
    ],
})
export class ChatNewComponent {
    /**
     * Control tracking currently selected collection
     */
    collectionControl = new FormControl<getCollections_collections | undefined>(
        undefined,
        // Collection is required if the current organization has feature base model chat enabled
        this.organization.currentOrganization$.value?.settings?.features.includes('BaseModelChat') ? [Validators.required] : [],
    );

    /**
     * Smart select settings for collection selection
     */
    selectCollection: SmartSelectSettings = {
        control: this.collectionControl,
        placeholder: $localize`Collectie selecteren`,
        query: this.apollo.getCollections.bind(this.apollo),
        fixedWhere: {
            deleted_at: { _is_null: true },
            organization_id: { _eq: this.organization.currentOrganization$.value?.id },
            _or: [
                {
                    private: { _eq: true },
                    created_by_id: { _eq: this.user.profile.id },
                },
                {
                    private: { _eq: false },
                },
            ],
        } as Collections_Bool_Exp,
        pageSize: 100,
        queryErrorMessage: $localize`Collecties laden mislukt`,
    };

    constructor(
        private apollo: ApolloService,
        private router: Router,
        public connection: ConnectionService,
        public organization: OrganizationService,
        private user: UserService,
    ) {
        // Immediately navigate to selected collection chat if this organization does not have base model chat feature
        if (!organization.currentOrganization$.value?.settings?.features.includes('BaseModelChat')) {
            // Subscribe to control changes and update url accordingly
            this.collectionControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((value) => {
                if (value) {
                    this.router.navigate(['chat'], { queryParams: { collection: value.id } });
                }
            });
        }
    }

    /**
     * Navigate to chatting in a collection if the collectionControl is valid
     * If not, mark it as touched so it outlines in red
     */
    navigateToCollectionChat(): void {
        if (this.collectionControl.valid && this.collectionControl.value) {
            this.router.navigate(['chat'], { queryParams: { collection: this.collectionControl.value.id } });
        } else {
            this.collectionControl.markAsTouched();
        }
    }
}
